import {
	drawPointsAnim,
	drawAngleAnim,
	drawLineAnim,
	drawCircleAnim,
	rotateCircleAnim,
} from "../../../../../../src/animation/Circle/helpers/drawHelpers";

import { INITIAL_RADIANS } from "../../types/Config";
import { normalizeRadian } from "../../../../../../src/utils/math/normalizeRadian";
import { ContextType } from "../../types/interface";


export async function runCircleAnimation(context: ContextType, onComp: () => void) {
	const {
		circle,
		LineManager,
		PointManager,
		AngleManager,
		cCoord,
	} = context;


	const centerPoint = PointManager.getPoints()[0];
	const centerPointCoord = PointManager.getPointsCoord()[0];
	const pointsCoord = PointManager.getRedPointsCoord();
	const tangentCoords = PointManager.getTangentCoords();
	const RedPoints = PointManager.getRedPoints();
	const initialRadian = PointManager.getInitialRadians();
	const angles = AngleManager.getAngles();

	AngleManager.draw(pointsCoord, tangentCoords);
	circle.radians = [...INITIAL_RADIANS, ...INITIAL_RADIANS];
	drawPointsAnim([centerPoint]);
	await drawCircleAnim(circle, INITIAL_RADIANS[0] + Math.PI * 2, 0, true, cCoord);

	await drawLineAnim(LineManager.lines[0], centerPointCoord, pointsCoord[0]);
	await drawLineAnim(LineManager.lines[1], tangentCoords[0], tangentCoords[1]);

	drawAngleAnim(angles[0], "90");

	await rotateCircleAnim((v) => {
		const arr = Array(1).fill(v).map((v, vI) => ({ pTag: RedPoints[vI].tag, radian: normalizeRadian(initialRadian[vI] + v) }));
		PointManager.setRadian(arr)
	});
	await drawPointsAnim(RedPoints);
	onComp();
}